var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C24.8366 32.0127 32 24.8493 32 16.0127C32 7.17614 24.8366 0.0126953 16 0.0126953C7.16344 0.0126953 0 7.17614 0 16.0127C0 24.8493 7.16344 32.0127 16 32.0127Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 16.0126C31.9998 9.66922 28.3082 4.18822 22.9563 1.60022V30.4249C28.3082 27.837 31.9998 22.356 31.9998 16.0126V16.0126Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0126C0 22.356 3.69156 27.837 9.0435 30.425V1.60022C3.69156 4.18822 0 9.66922 0 16.0126Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 18.0995L21.5652 16.7082L20.1739 16.0125V14.6212L17.3913 16.0125L18.7826 13.2299H17.3913L16 11.143L14.6087 13.2299H13.2174L14.6087 16.0125L11.8261 14.6212V16.0125L10.4348 16.7082L13.2174 18.0995L12.5218 19.4908H15.3044V21.5777H16.6956V19.4908H19.4783L18.7826 18.0995Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.ebd25a32.svg";
export { ForwardRef as ReactComponent };